<template>
  <div class="select-control">
    <select @change="selectedValueChanged($event)" :value="modelValue" :required="required">
      <option value :disabled="required">{{ emptyTitle }}</option>
      <option v-for="option in options" :key="option.value" :value="calculatedValue(option)">
        {{ calculatedText(option) }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  name: "UkiSelectControl",
  props: ["options", "emptyTitle", "modelValue", "required", "textField", "valueField"],
  emits: ["update:modelValue"],
  methods:{
    selectedValueChanged(event){
      this.$emit("update:modelValue", event.target.value)
    },
    calculatedText(option){
      let text = this.textField ?? "text"
      return option[text]
    },
    calculatedValue(option){
      let value = this.valueField ?? "value"
      return option[value]
    },
  }
}
</script>

<style scoped>

</style>